import { Link } from '@tanstack/react-router';
import React from 'react';

interface BuiltByPillProps {
  className?: string;
}

const BuiltByPill: React.FC<BuiltByPillProps> = ({ className = '' }) => {
  return (
    <Link
      to="https://structuredlabs.com"
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-1 text-xs text-muted-foreground border border-gray-200 rounded-full px-2 py-2 bg-white/80 backdrop-blur-sm hover:bg-gray-50 transition-colors ${className}`}
    >
      <span>Built by</span>
      <img
        src="/structuredlabs.png"
        alt="Structured Labs"
        className="h-2.5 w-auto filter grayscale opacity-70"
      />
    </Link>
  );
};

export default BuiltByPill; 